// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const AttentionSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M124.8 24c-26.7 5.6-47.9 17.2-66.5 36.3-10.6 10.9-16.7 19.3-22.8 31.3-9.4 18.3-13.6 36.4-13.6 58.4 0 36.3 12.8 66.8 38.4 91.7 10.9 10.6 19.3 16.7 31.3 22.8C110 273.9 127.8 278 150 278c22.2 0 40-4.1 58.4-13.5 12-6.1 20.4-12.2 31.3-22.8 25.6-25 38.4-55.4 38.4-91.7 0-28.4-7.8-53-23.7-75.1-6.7-9.2-21.3-23.7-30.5-30.2-14.2-10-32.6-17.7-50.8-21.1-11.8-2.3-36.8-2.1-48.3.4zm52.5 18c39.7 10.7 70 41.2 80.9 81.2 2 7.2 2.2 10.7 2.2 26.8s-.2 19.6-2.2 26.8c-10.9 40.2-41.2 70.5-81.4 81.4-7.2 2-10.7 2.2-26.8 2.2s-19.6-.2-26.8-2.2C83 247.3 52.7 217 41.8 176.8c-2-7.2-2.2-10.7-2.2-26.8s.2-19.6 2.2-26.8c10.9-40.1 42-71.3 80.9-81.1 11.4-2.9 12.3-3 30.3-2.6 12.9.3 18.2.8 24.3 2.5z" />
      <path d="M142 113.8c0 15.4.3 35.4.7 44.5l.6 16.7h13.4l.6-16.7c.4-9.1.7-29.1.7-44.5V86h-16v27.8zM140 204v10h20v-20h-20v10z" />
    </svg>
  )
}
